import styled from 'styled-components';

export const Container = styled.div`
  background: #ebebeb;
  min-height: 100vh;
`;

export const AdminContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px 40px;
`;
